import React from 'react';
import axios from 'axios';
import {withRouter} from "react-router-dom";
import renderHTML from 'react-render-html';

import Accordion from "../../components/Accordion/index";
import CollapsiblePanel from "../../components/Accordion/CollapsiblePanel";
import Loading from "../../components/Loading/index";

class EducationMaterialPreview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: this.props.match.params.id ? true : false,
            name: '',
            materialText: '',
            questions: []
        }
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getEducationMaterial();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getEducationMaterial();
        }
    }

    getEducationMaterial() {
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.educationMaterials + "/" + this.props.match.params.id, config)
            .then((response) => {
                if(!this._componentWillUnmount) {
                    this.setState({
                        ...response.data,
                        loading: false
                    });
                }
            }).catch((error) => {
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst vzdělávací materiál!');
                this.props.history.push('/educationMaterials');
                console.log('Axios error: ', error);
            });
        }
    }

    render () {

        let {name, shortText, materialText, pictureLink, questions} = this.state;

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Vzdělávací materiál: {name}</h2>
                    <div className="clearfix"/>
                </div>
                {
                    this.state.loading ?
                        <div className="x-content">
                            <Loading/>
                        </div> :
                        <div className="x-content">
                            <div className="row">
                                {pictureLink && <div
                                    className="col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <img className="center-block img-responsive" src={`${__APIURL__}/${pictureLink}`}
                                         alt="Obrázek speciálu"/>
                                </div>}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h4>Krátký popis vzdělávacího materiálu</h4>
                                    {shortText}
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h4>Obsah vzdělávacího materiálu</h4>
                                    {renderHTML(materialText)}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h4>Otázky</h4>
                                    <Accordion>
                                        {
                                            [...questions].map((question) => {
                                                let heading = "Otázka č. " + question.name;
                                                return (
                                                    <CollapsiblePanel key={question.id} heading={heading}>
                                                        {question.pictureLink && <div
                                                            className="col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                            <img className="center-block"
                                                                 src={`${__APIURL__}/${question.pictureLink}`}
                                                                 alt="Obrázek otázky"/>
                                                        </div>}
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <h2>Základní údaje:</h2>
                                                            <table className="table table-striped">
                                                                <tbody>
                                                                <tr>
                                                                    <th>Znění otázky:</th>
                                                                    <td>{question.text}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>Vysvětlení otázky:</th>
                                                                    <td>{question.explanation}</td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        {
                                                            question.tagIds && question.tagIds.length > 0 &&
                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                <h2>Tagy:</h2>
                                                                {
                                                                    [...question.tagIds].map((tag) => <span
                                                                        className="myTag">{tag.name}</span>)
                                                                }
                                                            </div>
                                                        }
                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <h2>Odpovědi:</h2>
                                                            <table className="table">
                                                                <thead>
                                                                <tr>
                                                                    <th>Číslo odpovědi</th>
                                                                    <th>Znění odpovědi</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {
                                                                    question.answers.map((answer, index) => {
                                                                        let correct = answer.correctness ? 'correct' : 'incorrect';
                                                                        return (
                                                                            <tr key={index} className={correct}>
                                                                                <td>{answer.name}</td>
                                                                                <td>{answer.text}</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </CollapsiblePanel>
                                                );
                                            })
                                        }
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default withRouter(EducationMaterialPreview);



/** WEBPACK FOOTER **
 ** ./src/containers/EducationMaterials/EducationMaterialPreview.js
 **/